"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _Documents = require("./Documents");
Object.keys(_Documents).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _Documents[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _Documents[key];
    }
  });
});